/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';

export class immunization extends IceEntity {
  immunization_key: string = "";
  system_entry_date: any = NaN;
  administered_code: string = "";
  administered_amount: number = 0.0;
  administered_units: string = "";
  administered_dosage_form: string = "";
  administration_notes_code: string = "";
  administered_per_time_unit: string = "";
  administered_strength: number = 0.0;
  administered_strength_units: string = "";
  substance_lot_number: string = "";
  substance_expiration_date: any = NaN;
  substance_manufacturer_code: string = "";
  substance_treatment_refusal_reason: string = "";
  indication: string = "";
  completion_status: string = "";
  action_code: string = "";
  administered_drug_strength_volume: number = 0;
  administered_drug_strength_volume_units: string = "";
  administered_barcode_identifier: string = "";
  pharmacy_order_type: string = "";
  medical_service_key: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
    return "IMMUNIZATION";
  }
}
